import React, { useEffect, useState } from 'react';
import { globalSearch, getOttSettings } from '../../../Api/api';
import AssetCard from './AssetCard';
import AnalyticsManager from '../../../analytics/analyticsManager';
import { ANALYTICS_EVENTS } from '../../../constant';

const SearchComponentWeb = ({ searchKey }) => {
    const [ottSetting, setOttSetting] = useState({});
    const [searchResults, setSearchResults] = useState([]);
    const [message, setMessage] = useState('');

    useEffect(() => {
        const fetchSettings = async () => {
            const res = await getOttSettings();
            if (res.success) setOttSetting(res.data);
        };
        fetchSettings();
    }, []);

    useEffect(() => {
        if (searchKey.trim().length > 0) {
            const handler = setTimeout(() => {
                performSearch();
            }, 1000);
            return () => {
                clearTimeout(handler);
            };
        } else {
            setSearchResults([]);
            setMessage('Search for your favorite movies and shows');
        }
    }, [searchKey]);

    const performSearch = async () => {
        const res = await globalSearch(searchKey);

        if (res.success) {
            if (res.data.length > 0) {
                AnalyticsManager().logEvent(ANALYTICS_EVENTS.CONTENT_SEARCH, res.data);
                setSearchResults(res.data);
                setMessage('');
            } else {
                setSearchResults([]);
                setMessage('No results found');
            }
        } else {
            setSearchResults([]);
            setMessage(res.message || 'Something went wrong');
        }
    };

    return (
        <div>
            {/* Suggestion Tags
                 {suggestions.map((tag, index) => (
               {searchKey.trim().length > 0 && (
                <div style={{ marginBottom: '20px', display: 'flex', gap: '10px', flexWrap: 'wrap' }}>
                        <div key={index} style={{
                            backgroundColor: '#1f1f23',
                            padding: '8px 12px',
                            borderRadius: '20px',
                            fontSize: '14px',
                            cursor: 'pointer'
                        }}>{tag}</div>
                    ))}
                </div>
            )} */}

            {/* Results */}
            {searchResults.length > 0 ? (
                <div style={{
                    display: 'grid',
                    gridTemplateColumns: 'repeat(auto-fill, minmax(180px, 1fr))',
                    gap: '20px'
                }}>
                    {searchResults.map((ottAsset, index) => (
                        <AssetCard
                            key={index}
                            ottSetting={ottSetting}
                            ottAsset={ottAsset}
                        />
                    ))}
                </div>
            ) : (
                <div style={{
                    marginTop: '50px',
                    color: 'gray',
                    textAlign: 'center',
                    fontSize: '18px'
                }}>{message}</div>
            )}
        </div>
    );
};

export default SearchComponentWeb;
